import { RouterProvider } from "react-router-dom"
import { router } from "@/shell/router"

export function App() {
  return <RouterProvider router={router} />
}
